import { RouterProvider } from 'react-router';
import { router } from './router/router';
import { AppProviders } from './setup/app-providers';

export function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
